// @flow
import EXIF from 'exif-js'

export const compressImg = (file: File, rate?: string) => {
  var reader = new window.FileReader()
  reader.readAsDataURL(file)
  // $FlowFixMe
  return new Promise(resolve => {
    reader.onload = function () {
      let img = new Image()
      img.src = this.result
      img.onload = function () {
        let base64 = compress(img, rate)
        let imgFile = base64ToFile(base64, file.name)
        resolve(imgFile)
      }
    }
  })
}

export const compress = (img: Image, rate?: string) => {
  let canvas = document.createElement('canvas')
  let tCanvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const tctx = tCanvas.getContext('2d')
  let width = img.width
  let height = img.height
  // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio = width * height / 4000000
  if (ratio > 1) {
    ratio = Math.sqrt(ratio)
    width /= ratio
    height /= ratio
  } else {
    ratio = 1
  }
  canvas.width = width
  canvas.height = height
  // 铺底色
  ctx.fillStyle = '#fff'

  let orientation
  EXIF.getData(img, function () {
    orientation = EXIF.getTag(this, 'Orientation')
  })
  if (orientation === 3 || orientation === 6 || orientation === 8) {
    switch (orientation) {
      // iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)
      case 6: {
        canvas.width = height
        canvas.height = width
        ctx.translate(canvas.width, 0)
        ctx.rotate(90 * Math.PI / 180)
        break
      }
      // iphone横屏拍摄，此时home键在左侧
      case 3: {
        ctx.translate(canvas.width, canvas.height)
        ctx.rotate(180 * Math.PI / 180)
        break
      }
      // iphone竖屏拍摄，此时home键在上方
      case 8: {
        canvas.width = height
        canvas.height = width
        ctx.translate(0, canvas.height)
        ctx.rotate(270 * Math.PI / 180)
        break
      }
      default: {
      }
    }
  }

  ctx.fillRect(0, 0, width, height)

  // 如果图片像素大于100万则使用瓦片绘制
  let count = width * height / 1000000
  if (count > 1) {
    count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片

    // 计算每块瓦片的宽和高
    let nw = ~~(width / count)
    let nh = ~~(height / count)

    tCanvas.width = nw
    tCanvas.height = nh

    for (var i = 0; i < count; i++) {
      for (var j = 0; j < count; j++) {
        tctx.drawImage(
          img,
          i * nw * ratio,
          j * nh * ratio,
          nw * ratio,
          nh * ratio,
          0,
          0,
          nw,
          nh
        )

        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height)
  }
  // 进行最小压缩
  let _rate = Number(rate) || 0.1
  const ndata = canvas.toDataURL('image/jpeg', _rate)
  tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
  return ndata
}

export const base64ToFile = (bases64Str: string, fileName: string) => {
  let byteString = atob(bases64Str.split(',')[1])
  let mimeString = bases64Str
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]
  // 类型数组
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return {
    blob: new Blob([ia], {
      type: mimeString
    }),
    fileName
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/util/compressImg.js